<template>
  <div v-if="group.Group === 'Color' || group.Group === 'ColorGroupName'">
    <label
      class="tw-flex tw-text-sm tw-items-center tw-mb-0.5 tw-mr-10"
      :class="item.Disabled ? 'disabled' : ''"
    >
      <span
        :style="{
          backgroundColor: item.Code,
          borderTop: '1px solid' + item.Code,
          borderBottom: '1px solid' + item.Code,
        }"
        class="tw-w-20 tw-py-0.5 tw-h-full tw-mt-1 tw-mb-1"
        >&nbsp;</span
      >
      <input
        class="tw-hidden"
        type="checkbox"
        autocomplete="off"
        :disabled="item.Disabled"
        :checked="item.Selected"
        :value="item.Value"
        :name="item.Name"
        @change="
          $emit('filterChange', {
            Item: item,
            Group: group.Group,
            index: index,
            Type: group.Type,
            Type: 'Checkbox',
          })
        "
      />
      <span
        class="
          tw-px-2
          tw-py-0.5
          tw-border
          tw-border-solid
          tw-border-gray-300
          tw-rounded
          tw-rounded-tl-none
          tw-rounded-bl-none
          tw-border-l-0
          tw-w-full
          tw-flex
          tw-justify-between
          tw-items-center
        "
        ><span :class="item.Selected ? 'tw-font-bold' : ''">
          {{ item.Text }}
        </span>
        <CheckIcon
          v-if="item.Selected"
          class="tw-h-5 tw-w-5"
          aria-hidden="true"
        />
      </span>
    </label>
  </div>

  <label v-else class="tw-flex tw-text-sm tw-mb-0.5 tw-items-center">
    <input
      class="tw-text-gray-600"
      type="checkbox"
      autocomplete="off"
      :disabled="item.Disabled"
      :checked="item.Selected"
      :value="item.Value"
      :Name="item.Name"
      @change="
        $emit('filterChange', {
          Item: item,
          Group: group.Group,
          index: index,
          Type: 'Checkbox',
        })
      "
    />
    <span class="tw-ml-2" :class="item.Selected ? 'tw-font-bold' : ''">
      {{ item.Text }}
    </span>
  </label>
</template>

<script>
import { CheckIcon } from "@heroicons/vue/solid";
// import InfoText from "../InfoText.vue";

export default {
  name: "Checkbox",
  props: {
    item: {
      Disabled: Boolean,
      Selected: Boolean,
      Value: String,
      Name: String,
    },
    index: Number,
    group: Object,
  },
  components: {
    CheckIcon,
    // InfoText
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
input[type="checkbox"]:disabled,
label.disabled {
  opacity: 0.3;
}
</style>
